import { createSelector } from 'redux-bundler'

import appConfig from '~/src/App/config'
import { EPOCH_DATE } from '~/src/Lib/Constants'
import { getActionType } from '~/src/Lib/createEntityBundle'
import getGlobal from '~/src/Lib/getGlobal'
import createLogger from '~/src/Lib/Logging'
import safeStorage from '~/src/Lib/safeStorage'
import { getDateTime } from '~/src/Lib/Utils'

const logger = createLogger('bundles/config')

const global = getGlobal()
const storage = safeStorage()
const configUpdate = getActionType('update', 'config')
const isDevDebug = storage.debug === 'true' && global.config.ENVIRONMENT !== 'production'

const FACILITY_TYPE_CONFIG_ADDITIONS = {
  DEFAULT: {
    MINIMUM_FROM: EPOCH_DATE,
  },
  GO: {
    get MINIMUM_FROM() {
      return getDateTime('now').startOf('day').minus({ days: 60 }).toFormat('yyyy-MM-dd')
    },
  },
}

export default {
  name: 'config',
  reducer: (state, action) => {
    let nextState
    if (!state) {
      const { testApp, testFacilityType } = storage
      nextState = {
        APP: [isDevDebug ? testApp : undefined, appConfig.APP, 'AROYA'].find(Boolean),
        FACILITY_TYPE: [isDevDebug ? testFacilityType : undefined, 'CORE'].find(Boolean),
      }
      const { [nextState.FACILITY_TYPE]: configAdditions = FACILITY_TYPE_CONFIG_ADDITIONS.DEFAULT } =
        FACILITY_TYPE_CONFIG_ADDITIONS
      Object.assign(nextState, configAdditions)
      return nextState
    }
    if (action.type === configUpdate) {
      return { ...state, ...action.payload }
    }
    return state
  },
  doConfigUpdate: payload => ({ type: configUpdate, payload }),
  selectConfig: createSelector(
    state => state.config,
    config => ({ ...appConfig, ...config }),
  ),
  reactConfigUpdateApp: createSelector('selectConfig', 'selectCurrentFacility', ({ APP, FACILITY_TYPE }, facility) => {
    const { testApp, testFacilityType } = storage
    const nextApp = isDevDebug && testApp ? testApp : facility?.app
    const nextFacilityType = isDevDebug && testFacilityType ? testFacilityType : facility?.facilityType
    const newConfig = {}

    if (nextApp && nextApp !== APP) newConfig.APP = nextApp
    if (nextFacilityType && nextFacilityType !== FACILITY_TYPE) {
      newConfig.FACILITY_TYPE = nextFacilityType
      const { [nextFacilityType]: additionalConfig = FACILITY_TYPE_CONFIG_ADDITIONS.DEFAULT } =
        FACILITY_TYPE_CONFIG_ADDITIONS
      Object.assign(newConfig, additionalConfig)
    }
    return Object.keys(newConfig).length ? { actionCreator: 'doConfigUpdate', args: [newConfig] } : null
  }),
}
